import axios, { AxiosError } from "axios"
import AuthProvider from "../../../../../common/authentication/authService";
import { GET_XTOKEN, VIEW_COURSE_DEFINITION_API } from "../../../../../common/apiEndPoint/apiEndPoint";
import { config } from "../../../../../common/authentication/config";

export const orgNameStatic = config?.ACADEMY_ORGNAME;
export const siteIdStatic = config?.SITE_ID;

axios.interceptors.request.use(
  async (config) => {
    if (config.url !== undefined) {
      let str = config.url;
      if (str.search("forge") < 0) {
        const token = await AuthProvider().getAccessToken();
        const xToken = await AuthProvider().getCookie("XSRF-TOKEN");
        if (token && xToken) {
          config.headers["Authorization"] = "Bearer " + token;
          config.headers["X-XSRF-TOKEN"] = xToken;
        }
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  (response) => response,
  async (err) => {
    const status = err.response?.status;
    const xToken = await AuthProvider().getCookie("XSRF-TOKEN");
    if (
      status === 400 &&
      err.response?.statusText == "Bad Request" &&
      (xToken == "" || xToken == undefined)
    ) {
      const token = await AuthProvider().getAccessToken();
      await axios.get(`${GET_XTOKEN}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      return axios.request(err.response.config);
    } else if (
      status === 401 &&
      err.response?.statusText == "Unauthorized" &&
      err.response?.data?.result?.toLowerCase() !== "unauthorized to access vcd"
    ) {
      if (AuthProvider().isAuthenticated() === false) {
        await AuthProvider().getRefreshToken();
      }
      return axios.request(err.response.config);
    }

    return Promise.reject(err);
  }
);

export const cookieVal = () => {
  const cookie = AuthProvider()?.getCookie("XSRF-TOKEN");
  if (cookie !== "") {
    return cookie;
  }
};

export const fetchViewCourseDefinitionApi = async (courseDefintionID: any) => {
  try {
    const res: any = await axios.get(
      `${VIEW_COURSE_DEFINITION_API}/${courseDefintionID}`,
      {
        headers: {
          Authorization: `Bearer ${courseDefintionID?.accessToken}`,
          Accept: "application/json",
          OrgName: orgNameStatic,
          siteId: siteIdStatic
        },
      }
    );
    return {
      success: true,
      data: res.data
    }
  } catch (error) {
    console.log('get course definition data error: ', error);
    return {
      success: false,
      status: (error as AxiosError)?.status || 500,
      message: (error as AxiosError)?.response?.data || "Unknown error occured",
    }
  }
};